<template>
    <span class="w-3/4 text-start self-start mb-5 text-base md:text-lg" :class="['text-' + options.color]">
        <slot></slot>
    </span>
</template>

<script>
    export default {
        name: 'Author',
        props: {
            options: null
        }
    };
</script>

<style lang="scss" scoped></style>
